export class ListRestoreTemplatesResponsePagination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListRestoreTemplatesResponsePagination.attributeTypeMap;
    }
    constructor() {
    }
}
